import { getCurrentPageHash, getPageUrl } from '../../../model/routing';
import config from '../../../config';

import Location from '../../../ports-frontend/Location';
import { UrlRedirection } from 'src/config/types';

async function redirectFromHash(
  urlRedirection: UrlRedirection,
  abortWhenTargetPathNotFound = false
) {
  const hash = await getCurrentPageHash();
  if (!hash) return;
  const currentBaseUrl = await getPageUrl();
  const targetBaseUrl = urlRedirection.targetBaseUrl || currentBaseUrl;
  const targetPath = urlRedirection.paths[hash];
  if (!targetPath && abortWhenTargetPathNotFound) {
    return;
  }
  if (!targetPath) {
    Location.replace('/', true);
  } else if (targetBaseUrl.startsWith(currentBaseUrl)) {
    Location.replace(targetPath, true);
  } else {
    Location.replaceToExternalPage(`${targetBaseUrl}${targetPath}`);
  }
}

export const redirectUrl = async () => {
  if (!config.urlRedirection) {
    return;
  }

  for (
    let urlRedirectionGroupIndex = 0;
    urlRedirectionGroupIndex < config.urlRedirection.length;
    urlRedirectionGroupIndex++
  ) {
    const urlRedirection = config.urlRedirection[urlRedirectionGroupIndex];
    const isNotLastGroup =
      urlRedirectionGroupIndex < config.urlRedirection.length - 1;

    if (urlRedirection.type === 'hash') {
      await redirectFromHash(urlRedirection, isNotLastGroup);
    }
  }
};
